<template>
  <nav id="header-container" class="w-full flex flex-row flex-wrap md:flex-nowrap justify-between items-center bg-black/40 backdrop-blur-sm py-2 px-4 border-b border-b-white/10 overflow-hidden fixed top-0 z-50">
    <div class="flex justify-start items-center z-10">
      <!-- <NuxtImg quality="50" class="h-6 cursor-pointer" width="73" height="24" alt="Oxbull.Tech Logo" @click="redirectToHome()" src="/oxb_green_header.png" /> -->
      <img @click="redirectToHome()" class="h-6 cursor-pointer" src="https://oxbull.twic.pics/oxbull-logo.webp?twic=v1/cover=-x32" alt="">
    </div>

    <div class="w-full hidden md:flex flex-1 justify-center items-center text-white font-semibold uppercase tracking-wider space-x-8 text-xs absolute top-[50%] -translate-y-[50%] left-[45%] lg:left-[50%] -translate-x-[50%] z-0">
      <a href="/hall-of-fame" class="hover:underline duration-300 cursor-pointer hover:text-turquoise-500">HALL OF FAME</a>
      <a href="https://oxbull.medium.com/" target="_blank" class="hover:underline duration-300 cursor-pointer hover:text-turquoise-500">OXBULL LABS BLOG</a>
    </div>

    <div class="hidden md:flex justify-end items-center space-x-2 z-10">
      <button v-if="$address" @click="disconnectWallet()" class="btn btn-xs btn-outline border-turquoise-500/20 rounded-full px-3 py-2 h-auto m-0 text-turquoise-500 hover:text-turquoise-900 hover:bg-turquoise-500 hover:border-transparent cursor-pointer">DISCONNECT [{{  $address.substring(0,8) }}...]</button>
      <WalletModal :class="['mr-2', $address ? 'hidden' : 'block']">
        <button class="btn btn-xs bg-turquoise-500/20 rounded-full border-none px-3 py-2 h-auto m-0 text-turquoise-500 hover:text-turquoise-900 hover:bg-turquoise-300 cursor-pointer">CONNECT WALLET</button>
      </WalletModal>
      <a target="_blank" href="/app" class="btn btn-xs bg-turquoise-500/20 rounded-full border-none px-3 py-2 h-auto m-0 text-turquoise-500 hover:text-turquoise-900 hover:bg-turquoise-300 cursor-pointer">LAUNCH APP</a>
    </div>

    <div class="md:hidden flex flex-row transition-all overflow-hidden">
      <button v-if="!isMobileMenuOpen" @click="setIsMobileMenuOpen()" class="icon-button h-9 w-9 text-white justify-center items-center" aria-label="Mobile header menu expand button">
        <Icon name="charm:menu-hamburger"/>
      </button>
      <button v-else @click="setIsMobileMenuOpen()" class="icon-button h-9 w-9 text-white justify-center items-center" aria-label="Mobile header menu shrink button">
        <Icon name="charm:cross"/>
      </button>
    </div>

    <div @blur="setIsMobileMenuOpen(false)" @mouseleave="setIsMobileMenuOpen(false)" :class="[!isMobileMenuOpen ? 'max-h-0' : 'max-h-screen', 'flex flex-col flex-nowrap w-full justify-center overflow-hidden transition-[max-height] duration-500 items-center md:hidden text-white']">
      <a href="/hall-of-fame" class="hover:underline duration-300 cursor-pointer hover:text-turquoise-500 my-2">HALL OF FAME</a>
      <div class="border-b-woodsmoke-600 border-b-[1px] flex w-full" />
      <a href="https://oxbull.medium.com/" target="_blank" class="hover:underline duration-300 cursor-pointer hover:text-turquoise-500 my-2">OXBULL LABS BLOG</a>
      <div class="border-b-woodsmoke-600 border-b-[1px] flex w-full" />
      <button v-if="$address" @click="disconnectWallet()" class="btn btn-xs btn-outline border-turquoise-500/20 rounded-full px-3 py-2 h-auto m-0 text-turquoise-500 hover:text-turquoise-900 hover:bg-turquoise-500 hover:border-transparent my-2 cursor-pointer">DISCONNECT WALLET</button>
      <WalletModal v-else :class="['mr-2 my-2', $address ? 'hidden' : 'block']">
        <button class="btn btn-xs bg-turquoise-500/20 rounded-full border-none px-3 py-2 h-auto m-0 text-turquoise-500 hover:text-turquoise-900 hover:bg-turquoise-300 cursor-pointer">CONNECT WALLET</button>
      </WalletModal>
      <div class="border-b-woodsmoke-600 border-b-[1px] flex w-full" />
      <a target="_blank" href="/app" class="btn btn-xs bg-turquoise-500/20 rounded-full border-none px-3 py-2 h-auto m-0 text-turquoise-500 hover:text-turquoise-900 hover:bg-turquoise-300 my-2 cursor-pointer">LAUNCH APP</a>
    </div>
  </nav>
</template>

<script setup>
import { ref, onMounted } from "vue";

// import { config } from "~/wagmiConfig.js";
// import { getAccount, watchConnections } from "@wagmi/core";
import { useUserStore } from "~/stores/user.js";

const userStore = useUserStore();

// const address = ref("");
const { $address, $deauth } = useNuxtApp()


// const unwatch = watchConnections(config, {
//   onChange(data) {

//     if(data){
//       let _account = getAccount(config);
//       address.value = _account.address;
//     } else{
//       address.value = null;
//     }
//   },
// });

const disconnectWallet = async () => {
  // userStore.deauth();
  $deauth()
};

// onUnmounted(() => {
//   unwatch();
// });

const isMobileMenuOpen = ref(false);

onMounted(() => {
  document.addEventListener("touchstart", setIsMobileMenuOpenFromTouch);
});

function setIsMobileMenuOpenFromTouch(e) {
  if (!document.getElementById("header-container").contains(e.target)) {
    isMobileMenuOpen.value = false;
  }
}

function setIsMobileMenuOpen(value) {
  isMobileMenuOpen.value = typeof value === "undefined" ? !isMobileMenuOpen.value : value;
}

function redirectToHome() {
  window.location.href = "/";
}
</script>
